<div class="card">
    <div class="card-body p-4">

        <!-- Header -->
        <div class="d-flex align-items-center justify-content-between mb-4">
            <h4 class="mb-0 d-flex align-items-center gap-2 fw-bold">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="17" cy="18" r="2" stroke="#545454" stroke-width="1.5"/>
                    <circle cx="7" cy="18" r="2" stroke="#545454" stroke-width="1.5"/>
                    <path d="M11 17H15M13.5 7H14.4429C15.7533 7 16.4086 7 16.9641 7.31452C17.5196 7.62904 17.89 8.20972 18.6308 9.37107C19.1502 10.1854 19.6955 10.7765 20.4622 11.3024C21.2341 11.8318 21.6012 12.0906 21.8049 12.506C22 12.9038 22 13.375 22 14.3173C22 15.5596 22 16.1808 21.651 16.5755C21.636 16.5925 21.6207 16.609 21.6049 16.625C21.2375 17 20.6594 17 19.503 17H19" stroke="#545454" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13 7L13.9942 9.48556C14.4813 10.7034 14.7249 11.3123 15.2328 11.6561C15.7407 12 16.3965 12 17.7081 12H21" stroke="#545454" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.86957 17C3.51684 17 2.84048 17 2.42024 16.5607C2 16.1213 2 15.4142 2 14V7C2 5.58579 2 4.87868 2.42024 4.43934C2.84048 4 3.51684 4 4.86957 4H10.1304C11.4832 4 12.1595 4 12.5798 4.43934C13 4.87868 13 5.58579 13 7V17H8.69565" stroke="#545454" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Checklist general
            </h4>
            <button class="btn btn-primary" (click)="goCreateChecklist()">
                Crear checklist
            </button>
        </div>

        <!-- Datos de la unidad -->
        <div class="unit-data-card mb-4" *ngIf="data.length">
            <div class="fw-bold mb-3 fs-6">Datos de la unidad</div>
            <div class="unit-data-table">
                <div class="row">
                    <div class="col-md-4">
                        <div class="fw-semibold mb-1">Usuario</div>
                        <div>{{ data[0]?.user?.name }}</div>
                    </div>
                    <div class="col-md-4">
                        <div class="fw-semibold mb-1">Unidad</div>
                        <div>{{ data[0]?.unit?.unit }}</div>
                    </div>
                    <div class="col-md-4">
                        <div class="fw-semibold mb-1">Placas</div>
                        <div>{{ data[0]?.unit?.plates }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Checklist items -->
        <div *ngFor="let item of data; let i = index" class="checklist-item">
            <div class="checklist-header border-bottom" (click)="toggleOpen(i)">
                <span class="fw-bold">Checklist #{{ i + 1 }}</span>
                <div class="d-flex align-items-center gap-2">
                    <span class="text-secondary">{{ formatDate(item.date) }}</span>
                    <svg class="chevron-icon" [class.open]="openStates[i]"
                        xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </div>
            </div>

            <div *ngIf="openStates[i]" class="checklist-body">

                <!-- Motor -->
                <div class="section-header">
                    <h4 class="mb-0">Motor</h4>
                </div>
                <div class="section-body">
                    <div class="mb-0 p-3 border rounded">
                        <div class="row">
                            <ng-container *ngFor="let campo of [
                                {nombre:'oil_level', label:'Nivel de aceite correcto'},
                                {nombre:'oil_leaks', label:'Sin fugas de aceite visibles'},
                                {nombre:'antifreeze_level', label:'Nivel de anticongelante correcto'},
                                {nombre:'hoses_in_good_condition', label:'Mangueras en buen estado (sin fugas ni grietas)'},
                                {nombre:'water_pump', label:'Bomba de agua sin fugas'},
                                {nombre:'correas_in_good_condition', label:'Correas en buen estado (sin grietas o desgaste)'},
                                {nombre:'battery_correct', label:'Batería sin sulfatación, fija y conectada correctamente'}
                            ]">
                                <div class="col-md-4 mb-3">
                                    <label class="switch-label">{{campo.label}}</label><br>
                                    <span>{{item[campo.nombre] ? 'Si' : 'No'}}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-12">
                            <div *ngIf="item?.images?.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let image of item?.images | filterByCategory:'engine'">
                                    <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + image?.path as src">
                                        <a [href]="src" data-toggle="lightbox">
                                            <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Frenos -->
                <div class="section-header">
                    <h4 class="mb-0">Frenos</h4>
                </div>
                <div class="section-body">
                    <div class="mb-0 p-3 border rounded">
                        <div class="row">
                            <ng-container *ngFor="let campo of [
                                {nombre:'brake_fluid_level', label:'Nivel de líquido de frenos correcto'},
                                {nombre:'brake_pedal', label:'Pedal responde firmemente'},
                                {nombre:'parking_brake', label:'Freno de estacionamiento operativo correcto'},
                                {nombre:'brake_lineLeaks', label:'Sin fugas en líneas de freno'},
                                {nombre:'brake_pump', label:'Compresor de aire en funcionamiento (si aplica)'},
                                {nombre:'brake_no_noise', label:'Sin ruidos anormales al frenar'}
                            ]">
                                <div class="col-md-4 mb-3">
                                    <label class="switch-label">{{campo.label}}</label><br>
                                    <span>{{item[campo.nombre] ? 'Si' : 'No'}}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-12">
                            <div *ngIf="item?.images?.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let image of item?.images | filterByCategory:'brakes'">
                                    <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + image?.path as src">
                                        <a [href]="src" data-toggle="lightbox">
                                            <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Suspensión y dirección -->
                <div class="section-header">
                    <h4 class="mb-0">Suspensión y dirección</h4>
                </div>
                <div class="section-body">
                    <div class="mb-0 p-3 border rounded">
                        <div class="row">
                            <ng-container *ngFor="let campo of [
                                {nombre:'shock_absorbersLeaks', label:'Amortiguadores sin fugas de aceite'},
                                {nombre:'shock_absorbers_no_jumps', label:'Sin golpeteo en suspensión'},
                                {nombre:'steering_sin_juego', label:'Dirección responde sin juego excesivo'},
                                {nombre:'steering_boxLeaks', label:'Caja de dirección sin fugas'},
                                {nombre:'steering_bushes_in_good_condition', label:'Bujes y terminales en buen estado'}
                            ]">
                                <div class="col-md-4 mb-3">
                                    <label class="switch-label">{{campo.label}}</label><br>
                                    <span>{{item[campo.nombre] ? 'Si' : 'No'}}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-12">
                            <div *ngIf="item?.images?.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let image of item?.images | filterByCategory:'suspension'">
                                    <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + image?.path as src">
                                        <a [href]="src" data-toggle="lightbox">
                                            <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Kilometraje inicial -->
                <div class="section-header">
                    <h4 class="mb-0">Kilometraje inicial</h4>
                </div>
                <div class="section-body">
                    <div class="mb-3 p-3 border rounded">
                        <div class="row mb-3">
                            <div class="col-md-4">
                                <label class="switch-label">Fecha</label><br>
                                <span>{{ formatDate(item.date) }}</span>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Kilometraje inicial</label><br>
                                <span>{{ item.mileage | number }} KM</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <div *ngIf="item?.images?.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let image of item?.images | filterByCategory:'mileage'">
                                    <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + image?.path as src">
                                        <a [href]="src" data-toggle="lightbox">
                                            <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Evidencias de la unidad -->
                <div class="section-header">
                    <h4 class="mb-0">Evidencias de la unidad</h4>
                </div>
                <div class="section-body">
                    <div class="mb-3 p-3 border rounded">
                        <div class="row g-3">
                            <div class="col-md-4">
                                <label class="switch-label">Frontal</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'front'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Frontal izquierda (3/4)</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'front_left'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Frontal derecha (3/4)</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'front_right'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Lateral izquierda</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'side_left'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Lateral derecha</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'side_right'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Trasera completa</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'full_rear'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="switch-label">Interior</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews-2col">
                                    <ng-container *ngFor="let preview of item?.images | filterByCategory:'inside'">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Llantas -->
                <div class="section-header">
                    <h4 class="mb-0">Llantas</h4>
                </div>
                <div class="section-body">
                    <div class="mb-0 p-3 border rounded">
                        <div class="row">
                            <div class="col">
                                <label class="switch-label">Número de llantas</label><br>
                                <span>{{ item.number_tires }}</span>
                            </div>
                            <div class="col">
                                <label class="switch-label">Número de refacciones</label><br>
                                <span>{{ item.number_repair }}</span>
                            </div>
                            <div class="col">
                                <div class="col mb-3">
                                    <label class="switch-label">Llantas de refacción en condiciones óptimas</label><br>
                                    <span>{{ item.repair_optimal ? 'Si' : 'No' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-2">
                            <label class="switch-label">Evidencia de llanta de refacción</label>
                            <div *ngIf="item?.images?.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let preview of item?.images | filterByCategory:'repair'">
                                    <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + preview?.path as src">
                                        <a [href]="src" data-toggle="lightbox">
                                            <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <hr>
                        <div *ngFor="let tire of getTiresArray(item.tires); let a = index">
                            <h6>Llanta {{ a + 1 }}</h6>
                            <div class="row mb-3">
                                <div class="col">
                                    <label class="switch-label">Marca</label><br>
                                    <span>{{ tire?.brand }}</span>
                                </div>
                                <div class="col">
                                    <label class="switch-label">Modelo</label><br>
                                    <span>{{ tire?.model }}</span>
                                </div>
                                <div class="col">
                                    <label class="switch-label">DOT / Serie de fabricación</label><br>
                                    <span>{{ tire?.dot }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col">
                                    <label class="switch-label">Kilometraje inicial</label><br>
                                    <span>{{ tire?.mileage }} km</span>
                                </div>
                                <div class="col">
                                    <label class="switch-label">Eje</label><br>
                                    <span>{{ tire?.axis }}</span>
                                </div>
                                <div class="col">
                                    <label class="switch-label">Posición</label><br>
                                    <span>{{ tire?.position }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col">
                                    <label class="switch-label">Presión</label><br>
                                    <span>{{ tire?.pressure }} psi</span>
                                </div>
                                <div class="col">
                                    <label class="switch-label">Milímetros</label><br>
                                    <span>{{ tire?.millimeters }} mm</span>
                                </div>
                                <div class="col"></div>
                            </div>
                            <div class="col-12 mb-3">
                                <label class="switch-label">Evidencia de llanta {{ a + 1 }}</label>
                                <div *ngIf="item?.images?.length" class="mt-2 evidence-previews">
                                    <ng-container *ngFor="let image of item?.images | filterByCategory:'tires_'+(a+1)">
                                        <div class="thumb-wrapper" *ngIf="url_path + '/storage/' + image?.path as src">
                                            <a [href]="src" data-toggle="lightbox">
                                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <hr *ngIf="a < getTiresArray(item.tires).length - 1">
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Empty state -->
        <div *ngIf="!data.length" class="text-center py-3">
            <h6 class="text-muted">No hay datos registrados</h6>
        </div>

    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
